import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../store/index';

import { IOfferStatsDispatchProps, IOfferStatsProps, OfferStats } from './index';

import { offerStatsPopupOpen } from '../../store/offer_stats_popup';

function mapStateToProps(state: IState): IOfferStatsProps {
  return {
    isFromBuilder: state.offerData.offer.isFromBuilder,
    offerStats: state.offerData.stats || null,
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>) {
  return {
    offerStatsPopupOpen: () => {
      dispatch(offerStatsPopupOpen());
    },
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OfferStatsContainer = connect<IOfferStatsProps, IOfferStatsDispatchProps, any>(
  mapStateToProps,
  mapDispatchToProps,
)(OfferStats);
